import {
  REQUEST as req,
  RESPONSE as res,
  FAILURE as fail,
  CLEAR as clr,
} from '../../actions/discovery/tournamentControl';

const initialState = {
  response: null,
  isLoading: false,
  error: null,
  // The control currently in flight so the board can disable just that one
  // button/row: 'stop' | 'cancel_training' | a preset_id (for cancel_entry).
  target: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case req: {
      const { op, presetId } = action.payload || {};
      const target = op === 'cancel_entry' ? presetId : op;
      return { ...state, isLoading: true, error: null, target };
    }
    case res:
      return {
        ...state, isLoading: false, response: action.payload, target: null,
      };
    case fail:
      return {
        ...state, isLoading: false, error: action.payload, target: null,
      };
    case clr:
      return { ...initialState };
    default:
      return state;
  }
};
